import React, { useState } from 'react';
import { Config } from '../../Config';

export default function EnvironmentInfo() {
  const [showEnvironment, setShowEnvironment] = useState(true);
  return (
    <>
      {Config.ENVIRONMENT_BANNER_ENABLED && showEnvironment && (
        <div className="prs-env">
          <div className="alert alert-danger alert-dismissible" role="alert">
            <span className="prs-env-text">
              Environment:{' '}
              <span className="prs-env-inner-text">{Config.ENVIRONMENT}</span>
            </span>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => setShowEnvironment(false)}
            >
              <i className="icon fas fa-times fa-lg" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      )}
      <div className="prs-build">
        <span>{Config.PRS_BUILD_VERSION}</span>
      </div>
    </>
  );
}
